import React, { useState } from "react";
import { FiFileText, FiPlus, FiSmartphone, FiTrash2, FiUploadCloud } from "react-icons/fi";
import { FileInput, Img, ReceiptStore } from "../../../../../../Components";
import apis from "../../../../../../Utils/apis";

function ExpenseAttachments({ attachments, runningOCR, updateAttachments }) {
	const [ActiveIndex, setActiveIndex] = useState(0);
	const isPdf = (file = {}) => {
		const name = `${file?.name || ""}`.toLowerCase();
		const url = `${file?.url || ""}`.toLowerCase();
		const mime = `${file?.mimeType || file?.mimetype || file?.type || ""}`.toLowerCase();
		return mime.includes("pdf") || name.endsWith(".pdf") || url.includes(".pdf");
	};
	const activeFile = attachments[ActiveIndex]?.file || {};
	const activeUrl = activeFile?.url || "";

	if (attachments.length) {
		return (
			<>
				<div className="flex h-full w-full flex-col gap-4 p-4 sm:gap-5 sm:p-6 lg:p-8">
					<div className="rounded-2xl border border-surface bg-canvas px-4 py-4 shadow-sm sm:px-5">
						<div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
							<div>
								<h4>Receipt Preview</h4>
								<div className="mt-1 text-xs text-secondary">
									Review the selected file. OCR will try to fill the form automatically from the first receipt.
								</div>
							</div>
							<div className="text-xs text-secondary">
								{attachments.length} file{attachments.length > 1 ? "s" : ""} added
							</div>
						</div>
					</div>
					<div className="relative flex min-h-[18rem] flex-1 items-center justify-center overflow-hidden rounded-2xl border border-surface bg-canvas p-3 shadow-sm sm:min-h-[22rem] lg:min-h-0">
						{isPdf(activeFile) ? (
							<div className="flex h-full min-h-[15rem] w-full max-w-[42rem] flex-col items-center justify-center gap-3 rounded-xl bg-light p-4 text-center">
								<FiFileText className="text-4xl text-secondary" />
								<div className="text-xs text-secondary">PDF attachment</div>
								<a href={activeUrl} target="_blank" rel="noreferrer" className="btn btn-dark btn-sm">
									Open PDF
								</a>
							</div>
						) : (
							<img src={activeUrl} alt="attachment" className="max-h-[60vh] w-full rounded-xl object-contain" />
						)}
						{runningOCR && (
							<div className="absolute left-0 top-0 right-0 bottom-0 bg-black frosted flex-center">
								<div>
									<div className="ocr-animation" />
									<div className="text-white text-center text-xs mt-6">Reading Receipt</div>
								</div>
							</div>
						)}
					</div>
					<div className="rounded-2xl border border-surface bg-canvas p-4 shadow-sm">
						<div className="mb-3 flex items-center justify-between gap-2">
							<div>
								<h5>Files</h5>
								<div className="text-xs text-secondary">Switch receipt, remove a file, upload a new one, or choose from Receipt Store.</div>
							</div>
						</div>
						<div className="flex flex-wrap items-start gap-3">
							{attachments.map((attachment, index) => (
								<div key={attachment?.file?.url || index} className="relative">
								{isPdf(attachment?.file) ? (
									<div onClick={() => setActiveIndex(index)} className={`flex h-20 w-20 cursor-pointer items-center justify-center rounded-xl border bg-light transition-all hover:scale-105 ${ActiveIndex === index ? "ring-2 ring-primary" : ""}`}>
										<FiFileText className="text-secondary" />
									</div>
								) : (
									<Img onClick={() => setActiveIndex(index)} src={attachment?.file?.url} className={`h-20 w-20 cursor-pointer rounded-xl transition-all hover:scale-105 ${ActiveIndex === index ? "ring-2 ring-primary" : ""}`} />
								)}
								<div onClick={() => updateAttachments((prev) => prev.filter((a) => a.file.url !== attachment.file.url))} className="absolute right-1 top-1 cursor-pointer rounded-full bg-dangerText p-2 text-sm text-white shadow-sm">
									<FiTrash2 />
								</div>
							</div>
							))}
							<div className="flex w-full flex-col gap-2 sm:w-auto">
								<FileInput url={apis.uploadReceipt} data={{}} extensions={[".jpg", ".jpeg", ".png", ".pdf"]} onUpload={(obj) => updateAttachments((prev) => [...prev, obj])}>
									<div className="btn btn-primary btn-sm w-full cursor-pointer gap-2">
										<FiPlus /> Upload Another
									</div>
								</FileInput>
								<ReceiptStore className="w-full" onSelect={(file) => updateAttachments((prev) => [...prev, { file }])} />
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}

	return (
		<>
			<div className="flex h-full w-full flex-col justify-center p-4 sm:p-6 lg:p-8">
				<div className="mx-auto w-full max-w-3xl rounded-3xl border border-surface bg-canvas p-5 shadow-sm sm:p-7">
					<div className="text-center">
						<h3>Add your receipt</h3>
						<div className="mt-2 text-sm text-secondary">
							Start by uploading an image or PDF. If the receipt is on your phone, use Receipt Store to pick it here.
						</div>
					</div>
					<div className="mt-5 rounded-2xl border border-dashed border-secondary/40 bg-light p-5 sm:p-6">
						<FileInput url={apis.uploadReceipt} data={{}} extensions={[".jpg", ".jpeg", ".png", ".pdf"]} onUpload={(obj) => updateAttachments((prev) => [...prev, obj])}>
							<div className="flex cursor-pointer flex-col items-center justify-center gap-4 rounded-2xl border border-secondary/30 bg-canvas px-6 py-8 text-center transition-all hover:border-primary/40 hover:bg-white">
								<div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10 text-primary">
									<FiUploadCloud className="text-3xl" />
								</div>
								<div>
									<div className="font-semibold text-dark">Upload from this device</div>
									<div className="mt-1 text-sm text-secondary">Choose a receipt image or PDF from your computer.</div>
								</div>
								<div className="inline-flex items-center rounded-full bg-primary px-4 py-2 text-sm font-semibold text-white shadow-sm">
									<FiPlus className="mr-2" />
									Choose Receipt File
								</div>
								<div className="text-xs text-secondary">Accepted formats: JPG, PNG, PDF</div>
							</div>
						</FileInput>
					</div>
					<div className="mt-4 grid gap-3 sm:grid-cols-2">
						<div className="rounded-xl border border-surface bg-light px-4 py-4">
							<div className="flex items-start gap-3">
								<div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-canvas text-secondary">
									<FiSmartphone className="text-lg" />
								</div>
								<div className="min-w-0">
									<div className="font-semibold text-dark">Already on your phone?</div>
									<div className="mt-1 text-xs text-secondary">Open Receipt Store to pick a file you uploaded from mobile.</div>
								</div>
							</div>
							<ReceiptStore className="mt-3 w-full !justify-center" onSelect={(file) => updateAttachments((prev) => [...prev, { file }])} />
						</div>
						<div className="rounded-xl border border-surface bg-light px-4 py-4 text-xs text-secondary">
							<div className="font-semibold text-dark">What happens next?</div>
							<div className="mt-2">After upload, we preview the receipt here and try to read the merchant, date, and amount automatically.</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default ExpenseAttachments;
